import React from 'react'
const ModalContext = React.createContext(null)

export default ModalContext
export const ModalContextProvider = ModalContext.Provider
export const ModalContextConsumer = ModalContext.Consumer
